import { defineStore } from 'pinia'
import { reactive } from 'vue'

class ToastButton {
  constructor({ text, action }) {
    ;(this.text = text), (this.action = action)
  }
}

class Toast {
  constructor({ id, title, body, theme, button, timer = true, link = null }, removeToast) {
    this.id = id
    this.title = title || 'Blank Toast'
    this.body = body || 'No text has been added to this toast'
    this.theme = theme || 'secondary'
    this.duration = 6000
    this.link = link
    if (button) {
      this.button = new ToastButton(button)
    }

    if (timer) {
      this.timer = setTimeout(() => {
        removeToast(this.id)
      }, this.duration)
    }
  }

  clearTimer() {
    clearTimeout(this.timer)
  }
}

export const useToastStore = defineStore('toast', () => {
  const toastStack = reactive([])

  function addToast(toastData) {
    const id = Date.now()
    const toast = new Toast({ id, ...toastData }, closeToast)
    toastStack.push(toast)
    return id
  }

  function closeToast(toastId) {
    const index = toastStack.findIndex((toast) => toast.id === toastId)
    if (index !== -1) {
      toastStack[index].clearTimer()
      toastStack.splice(index, 1)
    }
  }

  function pauseToast(id) {
    const i = toastStack.findIndex((t) => t.id === id)
    if (i != -1) {
      toastStack[i].clearTimer()
    }
  }

  return {
    toastStack,
    addToast,
    closeToast,
    pauseToast
  }
})
